import { render, staticRenderFns } from "./SetupSellerGoals.vue?vue&type=template&id=22b80bb8"
import script from "./SetupSellerGoals.vue?vue&type=script&lang=js"
export * from "./SetupSellerGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports